import React, { useState } from 'react';
import Dropdown from '../Dropdown';
import countries from "i18n-iso-countries"

type Props = {
    value: string;
    id?: string;
    error?: string;
    title?: string;
    callback?: (value: string) => void;
    label?: string;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
    tooltip?: string;
    className?: string;
    controlled?: boolean;
}

const CountriesDropdown = ({
    controlled = false,
    disabled = false,
    ...props
    }: Props) => {

    const [value, setValue] = useState('')

    const currentLanguage = localStorage.getItem("language") || "SE";
    const currentLanguageCode = currentLanguage === 'SE' ? 'sv' : 'en';
    const options = countries.getNames(currentLanguageCode)

    // Convert to array and sort Nordic countries first
    const optionsWithCode = Object.entries(options)
        .map(([code, name]) => ({
            title: name,
            id: code
        }))
        .sort((a, b) => {
            // Define priority order for Nordic countries
            const priorityOrder = ['SE', 'NO', 'FI', 'DK'];
            const aIndex = priorityOrder.indexOf(a.id);
            const bIndex = priorityOrder.indexOf(b.id);

            // If both are Nordic countries, sort by priority order
            if (aIndex !== -1 && bIndex !== -1) {
                return aIndex - bIndex;
            }
            // If only a is Nordic, it comes first
            if (aIndex !== -1) return -1;
            // If only b is Nordic, it comes first
            if (bIndex !== -1) return 1;
            // Otherwise sort alphabetically by title
            return a.title.localeCompare(b.title);
        });

    const handleChange = (newValue) => {
        setValue(newValue);
        if (props.callback) {
            props.callback(newValue);
        }
    }

    return <Dropdown
        controlled={controlled}
        disabled={disabled}
        options={optionsWithCode}
        callback={handleChange}
        {...props}

    />;
};

export default CountriesDropdown;